import type { FaireProductEntity } from "../../entity_types/product";

export const p_hxzv49u8am: FaireProductEntity = {
  token: "p_hxzv49u8am",
  type: "product",
  name: "Sesame Oil, Case of 4",
  brandToken: "b_bjdu29e326",
  brandName: "Sooki Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/45049ec3cb0ecf8f5bc4ce4d6416322ac0a09edd02aa9954583ad37a3339d763.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a971ebbd31a7e4b3bf56dbeba8ff8e11a5ac9dfedc3e9999d1ae05a78d355d4.png",
    "https://cdn.faire.com/fastly/a37a5a162f24799b32cb6185415a5bfb5d71a24063189719d7b722d0207cd29a.png",
    "https://cdn.faire.com/fastly/44111338e44cd92ba8d36ec9ed9bb28bb18753c6640d075056da2dacf93e554e.png",
    "https://cdn.faire.com/fastly/70590f165ca8afd4061f8a9a65567c8233f2b6cf5ca9406195bd8935431c998c.png",
    "https://cdn.faire.com/fastly/0e49a18bc6ac427773c24382dcbd0f3e91b1b4ef70416aab3731cc568004e999.jpeg",
  ],
  priceDollars: 14.99,
  description:
    "Sesame oil was always at the heart of our meals growing up—drizzled over rice, stirred into noodles, or finishing off our mom’s soups. But when we searched for that same taste and integrity in the U.S., we came up short. So we set out to create something better—starting from the seed up.\n\nWe taste-tested tons of sesame seeds and played with different roast levels over the years until we landed on the perfect balance—rich, toasty, and smooth. Our sesame seeds are carefully picked, roasted, and bottled at our farm in South Korea and is versatile enough to mix into dressings, add to stir fry, or finish any dish without overpowering it.\n\nFlavor notes: butter, nutty, smoky, subtle umami, clean and balanced finish.\n",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:57.564Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
